import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import fetch from 'isomorphic-fetch';

import {clearAlert, setAlert} from 'Skelet/src/modules/fetch.action.js';
import {handleChange} from 'Skelet/src/modules/functions.js';


class Echo extends React.Component {

  constructor(props) {
    super(props);

    let aD_echo = this.props.apiData["login"].echo;
    this.state = {
      echo_url:(aD_echo !== undefined && aD_echo.url !== undefined) ? aD_echo.url : "",
      echo_status:"",
      echo_txt:"",
      echo_ping_is_fetching:false,
    };
  }


  render() {
    return (
      <div className="container thin-container content">
        <strong>Echo</strong>
        <div className="card settings">
          <form onSubmit={(e) => this.handleSubmit(e)}>
            <div><input type="text" value={this.state.echo_url} onChange={(e) => handleChange(this, "echo_url", e)} placeholder="https://example.com" /></div>
            <div className="form-actions"><input type="submit" value="ping" disabled={this.props.echo_ping_is_fetching} /></div>
            <div style={{fontFamily:"monospace,monospace", wordBreak:"break-word", opacity:".3"}}>{this.state.echo_status}</div>
            <div style={{fontFamily:"monospace,monospace", wordBreak:"break-word"}}>{this.state.echo_txt}</div>
          </form>
        </div>
      </div>
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.echo_ping_is_fetching === false) {
      this.setState({echo_status:"", echo_txt:"", "echo_ping_is_fetching":true});
      this.fetchEcho();
    }
  }

  fetchEcho() {
    fetch(this.state.echo_url, {
      method: "GET",
    })
    .then(function(response) {
      return response.text().then(function(text) {
        return {status: response.status, url: response.url, text: text}
      })
    })
    .then(
      function(response_filtered) {
        let rf = response_filtered;
        this.setState({"echo_ping_is_fetching":false, "echo_txt":rf.text, "echo_status":rf.status, "echo_url":rf.url});
        this.props.apiData["login"].echo = {url:this.state.echo_url};
        this.props.clearAlert(); // bit dirty, but this triggers the lS save :)
      }.bind(this),
      function(err) {
        // Error WHILE fetching
        this.setState({"echo_ping_is_fetching":false, "echo_txt":"Error #102", "echo_status":""});
        this.props.setAlert("Error #102");
      }.bind(this)
    );
  }

} //class


function mapStateToProps(state) {
  return {
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    clearAlert,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Echo)



// WEBPACK FOOTER //
// ./src/containers/Echo.js